/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import handleEvalReportError, { resolveServerErrorMessage } from './evalErrors';
import notifyRubrics from './rubricsNotifications';
import { buildRubricsDeletePath } from './rubricsApiPaths';

/** DELETE /rubrics/:rubricId — removes a rubric and any schedule attached to it. */
export default class RubricsDeleteService extends BaseService {
  constructor() {
    super(constants.DELETE_RUBRICS_RUBRIC, 'RubricsDeleteStatus');
  }

  async handleEvent(eventName, event) {
    const { graphId, rubricId, tenantId } = event;
    const headers = utils.buildHeadersWithTenantId({ tenantId });
    const url = buildRubricsDeletePath({ rubricId, graphId });
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').delete(url, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').delete(url, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const store = Framework.getStoreRegistry().getStore('rubricsData');

    if (data?.success) {
      notifyRubrics({ type: 'success', langMessage: 'rubrics.DELETE_SUCCESS' });
      store.completeDelete();
      return;
    }

    notifyRubrics({ type: 'error', message: resolveServerErrorMessage(data), langMessage: 'rubrics.DELETE_ERROR' });
    store.failDelete();
  }

  handleError(error) {
    Framework.getStoreRegistry().getStore('rubricsData').failDelete();
    handleEvalReportError(error, 'rubrics.DELETE_ERROR');
  }
}
